import DescriptionStrategy from './DescriptionStrategy'
import messageResource from '../../../../messageResource'
import {Feature} from '../../../../features/constants'
import {AccessRights} from 'constants'

export default class StaffPerformanceDescriptionStrategy extends DescriptionStrategy {
    constructor({
        name = '',
        reportUrl = '',
    }) {
        super()

        this.params = {
            reportUrl,
            name,
        }

        this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {},
        }

        this.userType = null

        this.onStatePropertyChanged('userRights', (userRights) => {
            if (userRights[AccessRights.MANAGE_USERS])
                this.userType = UserTypes.MANAGE_ALL
            else if (userRights[AccessRights.EDIT_HIERARCHY] ||
                     userRights[AccessRights.GENERATE_MONEY_REPORTS] ||
                     userRights[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]) {
                this.userType = userRights[AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.SCOPE_WITH_TT : UserTypes.SCOPE_WITHOUT_TT
            } else {
                this.userType = userRights[AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.REGULAR_WITH_TT : UserTypes.REGULAR_WITHOUT_TT
            }
        })
    }

    getHeader() {
        return messageResource.getMessage(this.params.name) + ' ' + messageResource.getMessage('report.common.report')
    }

    getDescription() {
        const inDar = this.state.userInDar
        const leaveTimeFeature = this.state.enabledFeatures[Feature.LVT]

        let yourTeam
        let firstParagraph
        let secondParagraph
        let thirdParagraph
        switch (this.userType) {
            case UserTypes.REGULAR_WITH_TT:
                firstParagraph = messageResource.getEscapedMessage('dashboard.description.staff_output.regular_with_entertt.part1')
                secondParagraph = messageResource.getEscapedMessage('dashboard.description.staff_output.regular_with_entertt.part2')
                thirdParagraph = inDar ? messageResource.getEscapedMessage('dashboard.description.staff_output.regular_with_entertt.part3.dar')
                                       : messageResource.getEscapedMessage('dashboard.description.staff_output.regular_with_entertt.part3.not_dar')
                return this._createDescription(firstParagraph, secondParagraph, thirdParagraph)
            case UserTypes.REGULAR_WITHOUT_TT:
                return ''
            case UserTypes.SCOPE_WITH_TT:
                yourTeam = inDar ? messageResource.getEscapedMessage('dashboard.description.all_team') : messageResource.getEscapedMessage('dashboard.description.your_team')
                firstParagraph = messageResource.getEscapedMessage('dashboard.description.staff_output.scope_with_entertt.part1',
                    [yourTeam, (leaveTimeFeature ? messageResource.getEscapedMessage('dashboard.description.staff_output.scope_with_entertt.part1.leave_feature') : '')])
                secondParagraph = messageResource.getEscapedMessage('dashboard.description.staff_output.scope_with_entertt.part2')
                thirdParagraph = inDar ? '' : messageResource.getEscapedMessage('dashboard.description.staff_output.scope_with_entertt.part3')
                return this._createDescription(firstParagraph, secondParagraph, thirdParagraph)
            case UserTypes.SCOPE_WITHOUT_TT:
                yourTeam = inDar ? messageResource.getEscapedMessage('dashboard.description.all_team') : messageResource.getEscapedMessage('dashboard.description.your_team')
                firstParagraph = messageResource.getEscapedMessage('dashboard.description.staff_output.scope_without_entertt.part1',
                    [yourTeam, (leaveTimeFeature ? messageResource.getEscapedMessage('dashboard.description.staff_output.scope_without_entertt.part1.leave_feature') : '')])
                secondParagraph = messageResource.getEscapedMessage('dashboard.description.staff_output.scope_without_entertt.part2')
                thirdParagraph = inDar ? '' : messageResource.getEscapedMessage('dashboard.description.staff_output.scope_without_entertt.part3')
                return this._createDescription(firstParagraph, secondParagraph, thirdParagraph)
            case UserTypes.MANAGE_ALL:
                firstParagraph = messageResource.getEscapedMessage('dashboard.description.staff_output.ap_permission.part1')
                secondParagraph = messageResource.getEscapedMessage('dashboard.description.staff_output.ap_permission.part2')
                thirdParagraph = leaveTimeFeature ? messageResource.getEscapedMessage('dashboard.description.staff_output.ap_permission.part3') : ''
                return this._createDescription(firstParagraph, secondParagraph, thirdParagraph)
            default:
                return ''
        }
    }


    _createDescription(first, second, third) {
        return '<div>' +
               '  <div class="firstParagraph">' + first + '</div>' +
               '  <div class="secondParagraph">' + second + '</div>' +
               '  <div class="thirdParagraph">' + third + '</div>' +
               '</div>'
    }

    getDetailsCallback() {
        openUserGuidePage('report-staff-performance')
    }

    getGenerateCallback() {
        window.location.href = this.params.reportUrl
    }
}

const UserTypes = {
    REGULAR_WITH_TT: 'RegularUserWithEnterTT',
    REGULAR_WITHOUT_TT: 'RegularUserWithoutEnterTT',
    SCOPE_WITH_TT: 'ScopeUserWithEnterTT',
    SCOPE_WITHOUT_TT: 'ScopeUserWithoutEnterTT',
    MANAGE_ALL: 'ManageAccountsUser',
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/StaffPerformanceDescriptionStrategy.js